/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './survey-headers.reducer';

export const SurveyHeadersDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const surveyHeadersEntity = useAppSelector(state => state.surveyHeaders.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="surveyHeadersDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.surveyHeaders.detail.title">SurveyHeaders</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.surveyHeaders.id">Id</Translate>
            </span>
          </dt>
          <dd>{surveyHeadersEntity.id}</dd>
          <dt>
            <span id="surveame">
              <Translate contentKey="tinyMedicRestApp.surveyHeaders.surveame">Surveame</Translate>
            </span>
          </dt>
          <dd>{surveyHeadersEntity.surveame}</dd>
          <dt>
            <span id="instructions">
              <Translate contentKey="tinyMedicRestApp.surveyHeaders.instructions">Instructions</Translate>
            </span>
          </dt>
          <dd>{surveyHeadersEntity.instructions}</dd>
          <dt>
            <span id="otherHeaderInfo">
              <Translate contentKey="tinyMedicRestApp.surveyHeaders.otherHeaderInfo">Other Header Info</Translate>
            </span>
          </dt>
          <dd>{surveyHeadersEntity.otherHeaderInfo}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.surveyHeaders.active">Active</Translate>
            </span>
          </dt>
          <dd>{surveyHeadersEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.surveyHeaders.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{surveyHeadersEntity.cursor}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.surveyHeaders.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{surveyHeadersEntity.lastupdated}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.surveyHeaders.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{surveyHeadersEntity.microSec}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.surveyHeaders.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{surveyHeadersEntity.timestampentry}</dd>
        </dl>
        <Button tag={Link} to="/survey-headers" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/survey-headers/${surveyHeadersEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default SurveyHeadersDetail;
